module.exports = __webpack_public_path__ + "img/img151_13.eddc2ba1.png";